export { default } from './ComplianceWarningModal';
export type { ComplianceWarningModalProps } from './ComplianceWarningModal';
